// extracted by mini-css-extract-plugin
export default {"dark":"Sidebar-module--dark--39939","sidebar":"Sidebar-module--sidebar--1bfa1","sidebar__inner":"Sidebar-module--sidebar__inner--e8eff"};